import { render, staticRenderFns } from "./MainPage2025.vue?vue&type=template&id=76089330&scoped=true"
import script from "./MainPage2025.vue?vue&type=script&lang=js"
export * from "./MainPage2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76089330",
  null
  
)

export default component.exports